import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const cartsManifest: FeatureManifest = {
  id: 'orders-carts',
  path: 'orders/carts/:userId?',
  navPath: '/orders/carts',
  label: 'Giỏ hàng',
  requiredPermissions: ['orders'],
  navigationGroup: { id: 'orders', label: 'Quản lý đơn hàng' },
  load: () => import('./entry'),
}
